import React, { useMemo } from "react";
import { Spin } from "antd";
import { Chart, Geom, Axis, Tooltip, Legend } from "bizcharts";
import { normalizeTrendRows } from "../../../utils/statistics/statisticsUtils";

export default function TrendChart({
  data,
  loading,
  xField = "date",
  series = [{ field: "orders_count", name: "count", color: "#1677ff" }],
  height = 280,
}) {
  const chartData = useMemo(() => normalizeTrendRows(data), [data]);

  if (!loading && chartData.length === 0) {
    return <div className="statistics-page__empty-chart">—</div>;
  }

  return (
    <Spin spinning={loading}>
      <Chart height={height} autoFit data={chartData} padding={[20, 30, 50, 60]}>
        <Axis name={xField} />
        {series.map((item) => (
          <Axis key={item.field} name={item.field} />
        ))}
        <Tooltip crosshairs={{ type: "cross" }} shared />
        <Legend />
        {series.map((item) => (
          <Geom
            key={item.field}
            type="line"
            position={`${xField}*${item.field}`}
            color={item.color}
            size={2}
            shape="smooth"
          />
        ))}
      </Chart>
    </Spin>
  );
}
